import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as vinWonderPriceActions from '../../../../actions/VinWonderPriceAction';
import VinWonderPrices from './VinWonderPrices';

const mapStateToProps = state => {
    return {
        vinWonderPricetate: state.vinWonderPriceReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListVinWonderPrices: (filters) => dispatch(vinWonderPriceActions.getListVinWonderPrices(filters)),
        deleteVinWonderPriceDetail: (vinWonderPrice, filters) => dispatch(vinWonderPriceActions.deleteVinWonderPriceDetail(vinWonderPrice, filters))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(VinWonderPrices));
